
import { useState, useEffect } from "react";
import { Menu, X, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleBooking = () => {
    window.open("https://booksy.com/pl-pl/139856_chaba-thai-massage_masaz_20103_slupsk#ba_s=sh_1", "_blank");
  };

  const handleFacebook = () => {
    window.open("https://www.facebook.com/chabathai1/", "_blank");
  };
  
  const handleInstagram = () => {
    window.open("https://www.instagram.com/chabathaimassageslupsk/", "_blank");
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-dark/90 backdrop-blur-md py-4 shadow-md" : "bg-transparent py-6"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center ml-4 lg:ml-8">
            <img 
              src="/photos/logo.webp" 
              alt="ChaBa Thai Massage"
              width="200"
              height="200"
              className="h-24 w-auto drop-shadow-[0_0_8px_rgba(0,0,0,0.5)] transition-transform hover:scale-105"
            />
          </Link>
          
          <button
            className="lg:hidden text-gold"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className={`lg:flex items-center space-x-8 ${
            isMenuOpen 
              ? 'fixed top-[80px] left-0 right-0 bg-dark/95 backdrop-blur-md p-6 flex flex-col items-center w-full text-center space-y-6 lg:space-y-0 lg:p-0 lg:static lg:bg-transparent lg:flex-row shadow-lg lg:shadow-none' 
              : 'hidden lg:flex'
          }`}>
            <div className="flex flex-col lg:flex-row items-center space-y-6 lg:space-y-0 lg:space-x-8 w-full lg:w-auto">
              <Link to="/" className="text-gold-light hover:text-gold transition-colors w-full lg:w-auto text-center">
                Strona główna
              </Link>
              <Link to="/massage-types" className="text-gold-light hover:text-gold transition-colors w-full lg:w-auto text-center">
                Rodzaje masaży
              </Link>
              <Link to="/pricing" className="text-gold-light hover:text-gold transition-colors w-full lg:w-auto text-center">
                Cennik
              </Link>
              <Link to="/team" className="text-gold-light hover:text-gold transition-colors w-full lg:w-auto text-center">
                Masażystki
              </Link>
              <Link to="/location" className="text-gold-light hover:text-gold transition-colors w-full lg:w-auto text-center">
                Jak trafić
              </Link>
              <div className="flex items-center space-x-4">
                <button 
                  onClick={handleFacebook}
                  className="text-gold hover:text-gold-light transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook size={24} />
                </button>
                <button 
                  onClick={handleInstagram}
                  className="text-gold hover:text-gold-light transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={24} />
                </button>
                <button 
                  onClick={handleBooking}
                  className="bg-gold text-dark px-6 py-2 rounded-full hover:bg-gold-dark transition-colors w-full lg:w-auto"
                >
                  Zarezerwuj
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
